import {Injectable} from '@angular/core';
import {HttpModelConverter} from "../../../../../core/converter/httpModel.converter";
import {PermissionsConverter} from "../../../../../common/converter/permissions.converter";
import {InsolesProviderModelSummaryModel} from "./insolesProviderModelSummary.model";
import {LovValueSummaryConverter} from "../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class InsolesProviderModelSummaryConverter extends HttpModelConverter<InsolesProviderModelSummaryModel> {

    constructor(private permissionConverter: PermissionsConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter,) {
        super();
    }

    protected createInstance(): InsolesProviderModelSummaryModel {
        return new InsolesProviderModelSummaryModel();
    }

    protected enrichObject(result: InsolesProviderModelSummaryModel, src: InsolesProviderModelSummaryModel) {
        result.permissions = this.permissionConverter.convert(src.permissions);
        result.camMethod = this.lovValueSummaryConverter.convert(src.camMethod);
    }
}
